






































import { Vue } from "vue-property-decorator";
import { stadium_ground } from "@/@types/stadium/ground"
import Grounds from "@/views/stadium_ground/stadium_grounds.vue"
import Ground from "@/views/stadium_ground/stadium_ground.vue"

export default Vue.extend({
  name      : "StadiumGrounds",
  components: { Grounds, Ground },
  props     : {
    id        : { type: String, required: true },
    button    : { type: Boolean, default: true },
    editable  : { type: Boolean, required: true },
    stadium_id: { type: String, required: true },
    correct   : { type: Object, default() { return {} } },
  },
  data() {
    return {
      data   : [] as stadium_ground[],
      origin : [] as stadium_ground[],
      change : [] as any,
      total  : 0,
      columns: [
        { dataIndex: "index", title: "序号", align: "center", width: 80, customRender(text: any, record: any, index: number) { return index + 1 } },
        { dataIndex: "name", title: "片场名称", align: "center", ellipsis: true },
        { dataIndex: "status", title: "状态", align: "center", width: 120, scopedSlots: { customRender: "status" } },
        { title: "上移", align: "center", width: 120, scopedSlots: { customRender: "up" } },
        { title: "下移", align: "center", width: 120, scopedSlots: { customRender: "down" } },
      ],
      status: {
        0: { label: "下线", status: "error" },
        1: { label: "上线", status: "success" }
      },
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.data, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.list()
        /* this.show_grounds = true
        setTimeout(() => {
          this.show_grounds = false
        }, 10) */
      })
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.data, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    open_grounds() {
      this.$nextTick(() => {
        const grounds = this.$refs.grounds as any
        grounds.open()
      })
    },
    async list() {
      const params = { stadium_id: this.stadium_id }
      const res = await this.$store.dispatch("stadium/getStadiumGrounds", params);
      if (res.Code == 200) {
        this.data   = res.Data
        this.origin = res.Data
        this.total  = this.data.length
      }
    },
    up(i: number) {
      const data = this.$deep_copy(this.data)
      const up   = this.$deep_copy(data[i])
      const down = this.$deep_copy(data[i - 1])
      up.sn = data[i - 1].sn
      down.sn = data[i].sn
      data[i - 1] = up
      data[i] = down
      this.data = data
    },
    down(i: number) {
      const data = this.$deep_copy(this.data)
      const down   = this.$deep_copy(data[i])
      const up = this.$deep_copy(data[i + 1])
      up.sn = data[i].sn
      down.sn = data[i + 1].sn
      data[i] = up
      data[i + 1] = down
      this.data = data
    },
    submit() {
      const list = [] as stadium_ground[]
      for (const o of this.origin) {
        for (const v of this.data) {
          if (v.id == o.id && v.sn != o.sn) {
            list.push(v)
          }
        }
      }
      for (const v of list) this.save(v)
    },
    async save(params: stadium_ground) {
      const res = await this.$store.dispatch("stadium/editGround", params);
      if (res.Code != 200) {
        this.$error({ content: res.Message })
      }
    },
    add_ground() {
      const ground = this.$refs.ground as any
      ground.open(0)
    }
  }
})

